/* Precise Coffee — home grinder guide finder and grind-size scale. Loaded by sections/pc-grinder-guide.liquid. */
(function(){
  var SHOP={href:"/collections/coffee-grinders",label:"Shop coffee grinders"};
  var TYPES = {
    blade:{name:"Blade grinder", price:"£15–£40", short:"Blade",
      why:"A spinning blade chops the beans. Cheap and quick, but the grind is uneven. Only really suitable for cafetière on a tight budget.",
      pros:["Very cheap","Small and quick","Better than stale pre-ground"],
      cons:["Uneven grind, muddy taste","Can't grind for espresso","No real size setting"],
      chips:["Blade","Budget"], t:[1,1,4,2], best:"Cafetière on a tight budget",
      note:"We don't sell blade grinders. A hand burr grinder costs little more and is a different world."},
    hand:{name:"Hand grinder", price:"£40–£300", short:"Hand grinder",
      why:"A manual burr grinder you turn by hand. The best grind quality for the money, silent and portable. Espresso-capable models start from around £80.",
      pros:["Best quality per pound","Silent, needs no power","Great for travel"],
      cons:["Takes effort and time","One or two cups at a time","Tiresome for a busy household"],
      chips:["Conical burrs","Portable"], t:[4,4,1,5], best:"1–2 cups, travel, quiet mornings",
      note:"We don't currently stock hand grinders. Our compact single-dose electrics start at around £215 if you'd like the same quality without the effort."},
    filterburr:{name:"Filter burr grinder", price:"£50–£250", short:"Filter burr",
      why:"An electric hopper grinder tuned for pour-over, filter machines and cafetière. Consistent and easy, but not fine enough for espresso.",
      pros:["Even grind for filter","Push-button easy","Good value"],
      cons:["Can't do espresso","Beans go stale in the hopper","Can be noisy"],
      chips:["Electric","Hopper","Filter range"], t:[3,1,5,3], best:"Filter, pour-over, cafetière",
      note:"We don't sell filter-only grinders. Our single-dose grinders cover filter and cafetière beautifully, and give you espresso if you ever want it."},
    hopper:{name:"Hopper espresso grinder", price:"£150–£500", short:"Hopper espresso",
      why:"An electric grinder with a bean hopper on top and timed dosing into the portafilter. Press a button and it grinds for a set number of seconds. Convenient, but the beans in the hopper go stale and the dose drifts.",
      pros:["Press and go","Grinds straight into the portafilter","Fast and repeatable"],
      cons:["Retains a gram or more of old coffee","Beans stale in the hopper","Awkward to switch beans"],
      chips:["Timed dosing","Hopper"], t:[4,4,5,2], best:"Convenience over freshness",
      note:"We stock single-dose grinders instead. With a dosing cup and bellows the workflow is almost as quick, and every dose is fresh."},
    sdcon:{name:"Single-dose conical burr", price:"£250–£600", short:"Single-dose conical",
      why:"You weigh each dose and grind it all, so nothing is left behind to go stale. Conical burrs on a slow, geared motor: compact, quiet and forgiving, with a rounder, fuller cup.",
      pros:["Near-zero retention","Quiet and compact","Easy to switch beans or methods"],
      cons:["Weigh every dose","Slightly less clarity than flat burrs","Smaller burrs grind a little slower"],
      chips:["Single dose","Conical","Stepless"], t:[4,5,3,4], best:"Quiet kitchens, mixed roasts",
      shop:SHOP},
    sdflat:{name:"Single-dose flat burr", price:"£200–£800", short:"Single-dose flat",
      why:"Single dosing with 54–64 mm flat burrs for the clearest, most separated flavours. The home enthusiast's choice for specialty espresso and pour-over, with stepless adjustment and near-zero retention.",
      pros:["Top clarity and sweetness","Near-zero retention","Fast: 18 g in about 10 seconds"],
      cons:["Weigh every dose","Louder than a conical","Taller: check cupboard height"],
      chips:["Single dose","Flat","Stepless"], t:[5,5,3,2], best:"Specialty espresso and filter",
      shop:SHOP}
  };
  var ORDER=["blade","hand","filterburr","hopper","sdcon","sdflat"];

  var SCORES = {
    brew:{espresso:{sdflat:3,sdcon:3,hopper:3,hand:1,filterburr:-5,blade:-6},
          filter:{filterburr:3,hand:2,sdcon:2,sdflat:2,hopper:-1,blade:-1},
          press:{filterburr:3,hand:2,blade:1,sdcon:1,sdflat:1,hopper:-2},
          moka:{hand:2,sdcon:2,hopper:1,sdflat:1,blade:-3},
          both:{sdcon:3,sdflat:3,hand:2,hopper:-1,filterburr:-2,blade:-6}},
    power:{electric:{hand:-5},
           hand:{hand:5,sdcon:-1,sdflat:-1,hopper:-1,filterburr:-1,blade:-1},
           any:{}},
    volume:{1:{hand:2,blade:1},
            2:{hopper:1,sdcon:1,sdflat:1,filterburr:1,hand:-1},
            3:{hopper:2,sdflat:1,filterburr:1,hand:-4,blade:-2}},
    budget:{1:{hand:3,blade:2,hopper:-6,sdcon:-6,sdflat:-6},
            2:{hand:3,filterburr:3,blade:-1,sdflat:-1,sdcon:-3},
            3:{sdflat:3,sdcon:2,hopper:2,hand:1,blade:-3},
            4:{sdcon:3,sdflat:3,hopper:1,filterburr:-2,blade:-4},
            5:{sdflat:3,sdcon:2,hopper:1,filterburr:-3,blade:-4}},
    priority:{taste:{sdflat:2,sdcon:1,hand:1,blade:-3},
              easy:{hopper:3,filterburr:1,hand:-2},
              quiet:{hand:2,sdcon:2,hopper:-1,sdflat:-1},
              switch:{sdcon:3,sdflat:3,hand:2,filterburr:-1,hopper:-3}}
  };

  var SCALE=[
    ["Extra fine","Turkish coffee","Flour, icing sugar","~100 µm",2],
    ["Fine","Espresso","Fine salt","200–350 µm",3],
    ["Medium-fine","Moka pot, AeroPress","Table salt","350–600 µm",4],
    ["Medium","Pour-over (V60), filter machine","Sand","600–900 µm",5.5],
    ["Medium-coarse","Chemex, batch brew","Rough sand","800–1,000 µm",6.5],
    ["Coarse","Cafetière (French press)","Sea salt","1,000–1,200 µm",8],
    ["Extra coarse","Cold brew","Peppercorns, cracked","1,200–1,500 µm",10]
  ];

  function dots(n){var s="";for(var i=0;i<n;i++)s+="●";var e="";for(var j=n;j<5;j++)e+="●";return s+"<i>"+e+"</i>";}
  function esc(s){return String(s).replace(/&/g,"&amp;").replace(/[<]/g,"&lt;").replace(/"/g,"&quot;");}
  function el(id){return document.getElementById(id);}

  var cards=el("pcbg-typecards"), table=el("pcbg-ctable"), quiz=el("pcbg-quiz"), scale=el("pcbg-scale");
  if(!cards||!table||!quiz) return;

  if(scale){
    scale.innerHTML = SCALE.map(function(r){
      var d=r[4], count=Math.max(3,Math.round(26/d)), g='';
      for(var k=0;k<count;k++){g+='<i style="width:'+d+'px;height:'+d+'px"></i>';}
      return '<div class="pcbg-srow"><b>'+esc(r[0])+'</b>'+
        '<div class="pcbg-mid"><div>'+esc(r[1])+'</div><div class="pcbg-tex">Feels like '+esc(r[2].toLowerCase())+'</div><div class="pcbg-grains" aria-hidden="true">'+g+'</div></div>'+
        '<div class="pcbg-um">'+esc(r[3])+'</div></div>';
    }).join('');
  }

  cards.innerHTML = ORDER.map(function(k){var t=TYPES[k];return ''+
    '<article class="pcbg-type" id="pcbg-type-'+k+'">'+
      '<div class="pcbg-row"><h3 class="pcbg-h3">'+esc(t.name)+'</h3><span class="pcbg-band">'+esc(t.price)+'</span></div>'+
      '<p>'+esc(t.why)+'</p>'+
      '<div class="pcbg-pc"><div class="pcbg-pro"><h4>Good</h4><ul>'+t.pros.map(function(x){return '<li>'+esc(x)+'</li>';}).join('')+'</ul></div>'+
      '<div class="pcbg-con"><h4>Watch out</h4><ul>'+t.cons.map(function(x){return '<li>'+esc(x)+'</li>';}).join('')+'</ul></div></div>'+
      (t.note?'<p class="pcbg-r-note">'+esc(t.note)+'</p>':'')+
      '<div class="pcbg-meta">'+t.chips.map(function(c){return '<span class="pcbg-chip">'+esc(c)+'</span>';}).join('')+
        (t.shop?'<a class="pcbg-type-shop" href="'+esc(t.shop.href)+'">'+esc(t.shop.label)+' →</a>':'')+
      '</div>'+
    '</article>';}).join('');

  table.innerHTML = ORDER.map(function(k){var t=TYPES[k];return '<tr><th scope="row">'+esc(t.name)+'</th>'+
    t.t.map(function(n){return '<td><span class="pcbg-dots" aria-label="'+n+' out of 5">'+dots(n)+'</span></td>';}).join('')+
    '<td>'+esc(t.best)+'</td></tr>';}).join('');

  function answers(){var a={};var inputs=quiz.querySelectorAll('input[type=radio]:checked');for(var i=0;i<inputs.length;i++){a[inputs[i].name]=inputs[i].value;}return a;}
  function update(){
    var a=answers(), s={}; ORDER.forEach(function(k){s[k]=0;});
    for(var q in a){var m=(SCORES[q]||{})[a[q]]||{}; for(var k in m) s[k]+=m[k];}
    var ranked=ORDER.slice().sort(function(x,y){return s[y]-s[x];});
    var vals=ORDER.map(function(k){return s[k];});
    var min=Math.min.apply(null,vals), max=Math.max.apply(null,vals);
    var pct=function(k){return max===min?50:Math.round(8+92*(s[k]-min)/(max-min));};
    var top=TYPES[ranked[0]], second=TYPES[ranked[1]];
    el("pcbg-r-name").textContent=top.name;
    el("pcbg-r-price").textContent="Typical price: "+top.price;
    el("pcbg-r-why").textContent=top.why;
    el("pcbg-r-points").innerHTML=top.pros.map(function(p){return '<li>'+esc(p)+'</li>';}).join('');
    var note=el("pcbg-r-note");
    if(note){ if(top.note){note.textContent=top.note;note.hidden=false;}else{note.hidden=true;} }
    var shop=el("pcbg-r-shop");
    if(top.shop){shop.href=top.shop.href;shop.textContent=top.shop.label;shop.hidden=false;}else{shop.hidden=true;}
    el("pcbg-r-runner").innerHTML='Also worth a look: <b>'+esc(second.name)+'</b> ('+esc(second.price)+'). Best for '+esc(second.best.toLowerCase())+'.';
    el("pcbg-r-bars").innerHTML=ranked.map(function(k,i){return '<div class="pcbg-bar'+(i===0?' pcbg-top':'')+'"><span>'+esc(TYPES[k].short)+'</span><div class="pcbg-track"><div class="pcbg-fill" style="width:'+pct(k)+'%"></div></div><span class="pcbg-pct">'+pct(k)+'</span></div>';}).join('');
  }
  quiz.addEventListener("change",update);
  update();
})();
